import { render, staticRenderFns } from "./GalleryComponentCard.vue?vue&type=template&id=39e0347b&scoped=true"
import script from "./GalleryComponentCard.vue?vue&type=script&lang=js"
export * from "./GalleryComponentCard.vue?vue&type=script&lang=js"
import style0 from "./GalleryComponentCard.vue?vue&type=style&index=0&id=39e0347b&prod&scoped=true&lang=css"
import style1 from "./GalleryComponentCard.vue?vue&type=style&index=1&id=39e0347b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e0347b",
  null
  
)

export default component.exports